# This directive allows you to use tabs in a bootstrap style menu without the menu closing
angular.module('rjmNg.directives').directive "showTab", [
  () ->
    link: (scope, element, attrs) ->
      element.click (event) ->
        event.stopPropagation()
        $(element).tab('show')
  ]

